import { TabContainer } from "../../components/TabContainer";
import { Canvas } from "./Canvas";
import { CheckoutTabProviderContext } from "./CheckoutTabContext";
import { Sidebar } from "./Sidebar";
import { BuilderSidebar } from "./components/BuilderSidebar";
import { BuilderWrapper } from "./components/BuilderWrapper";

export const CheckoutTab = () => (
  <CheckoutTabProviderContext>
    <TabContainer variants="full-width" className="size-full">
      <BuilderWrapper>
        <BuilderSidebar className="flex w-[328px] flex-col gap-y-5">
          <Sidebar />
        </BuilderSidebar>
        <Canvas />
      </BuilderWrapper>
    </TabContainer>
  </CheckoutTabProviderContext>
);
